









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { doc } from '@/doc'
import { DocsendUser } from '@/DocsendUser'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import { gptResponse } from '../docsend'

@Component({
  name: 'DocGridComponent',
  components: { }
})
export default class DocGridComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null, required: true })
  public doc: doc

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  // public reactive member variables available to the html template
  public editing: boolean = false
  public editedTitle: string = null
  public editedDomain: string = null
  public notetaking: boolean = false
  public editedSharedNotes: string = null
  public editedPersonalNotes: string = null

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): DocsendUser { return this.$store.getters.userObject }
  public get isBookmarked(): boolean { return (this.$store.getters.userObject as DocsendUser).favorites && (this.$store.getters.userObject as DocsendUser).favorites.includes(this.doc.getIdAsString()) }
  public get hasNotes(): boolean { return this.doc.notes && this.doc.notes.length > 0 || this.doc.notesByUser && this.doc.notesByUser[ this.user.getIdAsString() ] && this.doc.notesByUser[ this.user.getIdAsString() ].length > 0 }

  public previewHTML(): string {
    const latestGPTResponse: gptResponse = this.doc.getLatestGptResponse()
    if (latestGPTResponse) {
      return latestGPTResponse.response.replaceAll('\n', '<br />').replace('35-word summary: ', '')
    }
    return this.doc.text[0] + '<br /><br />' + this.doc.text[1]
  }

  public clickedMoreLikeThis() {
    this.$emit("clicked-morelikethis", this.doc.getIdAsString())
  }
  public clickedEdit(): void {
    this.editing = true
    this.editedTitle = this.doc.title
    this.editedDomain = this.doc.deducedCompanyDomain
  }
  public clickedNotes(): void {
    this.notetaking = true
    this.editedSharedNotes = this.doc.notes
    this.editedPersonalNotes = this.doc.notesByUser[ this.user.getIdAsString() ]
  }
  public clickedCancel() {
    this.notetaking = false
    this.editing = false
  }
  public async clickedSaveNotes() {
    // send mutations to the server
    try {
      const url: string = utils.getURLprefix() + `/api/docs/${this.doc.getIdAsString()}`;
      const notesByUser: { [ userId: string ]: string } = this.doc.notesByUser
      notesByUser[ this.user.getIdAsString() ] = this.editedPersonalNotes
      const mutations = { notes: this.editedSharedNotes, notesByUser }
      this.$store.commit('setLoading', { loading: true });
      const response: any = await utils.makePutCall(url, mutations);

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      if (!response.data.doc) {
        utils.toast(this, 'Error', 'No doc returned')
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // modify our doc in memory
      this.doc.notes = response.data.doc.notes
      this.doc.notesByUser = response.data.doc.notesByUser

      this.notetaking = false

      // tell parent that we successfully updated a story so that it can resort
      this.$emit('edited', this.index, this.doc)

    } catch (error) {
      utils.toast(this, 'Error', 'Could not update doc')
      if (this.$store.state.devmode) console.log(error);
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }  }

  public async clickedSave() {
    // send mutations to the server
    try {
      const url: string = utils.getURLprefix() + `/api/docs/${this.doc.getIdAsString()}`;
      const mutations = { title: this.editedTitle, deducedCompanyDomain: this.editedDomain }
      this.$store.commit('setLoading', { loading: true });
      const response: any = await utils.makePutCall(url, mutations);

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      if (!response.data.doc) {
        utils.toast(this, 'Error', 'No doc returned')
        this.$store.commit('setLoading', { loading: false });
        return
      }

      // modify our doc in memory
      this.doc.title = response.data.doc.title
      this.doc.deducedCompanyDomain = response.data.doc.deducedCompanyDomain

      this.editing = false

      // tell parent that we successfully updated a story so that it can resort
      this.$emit('edited', this.index, this.doc)

    } catch (error) {
      utils.toast(this, 'Error', 'Could not update doc')
      if (this.$store.state.devmode) console.log(error);
    } finally {
      this.$store.commit("setLoading", { loading: false });
    }
  }
  public async clickedBookmark() {
    const url: string = utils.getURLprefix() + `/api/users/${this.doc.getIdAsString()}`;
    this.$store.commit('setLoading', { loading: true });
    try {
      const response: any = await utils.makePutCall(url, { command: "toggleFavorite", docId: this.doc.getIdAsString() });

      // error check
      if (response.data.error) {
        utils.toast(this, 'Error', response.data.error)
        this.$store.commit('setLoading', { loading: false });
        return
      }

      if (response.data.user) {
        const me: DocsendUser = new DocsendUser(response.data.user)
        me.updateMeToStoreAndLocalStorage()
      }

    } catch (e) {
      utils.toast(this, 'Error', 'Could not toggle bookmark')
      if (this.$store.state.devmode) console.log(e);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
